
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface MockBadgeProps {
  phase?: string;
  tooltip?: string;
  feature?: string;
}

export function MockBadge({ phase, tooltip, feature }: MockBadgeProps) {
  const defaultTooltip = phase 
    ? `This feature will be fully implemented in Phase ${phase}`
    : feature
      ? `${feature} functionality is using mock data for demonstration purposes`
      : "This feature is using mock data for demonstration purposes";
  
  const label = phase 
    ? `Phase ${phase}` 
    : feature 
      ? `${feature}` 
      : "Mock Data";
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="outline" 
            className="bg-gradient-to-r from-brand-purple to-brand-purple-light text-white border-brand-purple/20 cursor-help"
          >
            <Info className="h-3 w-3 mr-1" />
            {label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p className="max-w-xs text-sm">{tooltip || defaultTooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
